import Vue from 'vue';
import VueRouter from 'vue-router';
import Dashboard from '@/views/Dashboard.vue';
import Depots from '@/views/Depots.vue';
import Depot from '@/views/Depot.vue';
import Settings from '@/views/Settings.vue';
import Login from '@/views/Login.vue';
import store from '../store';

const mustBeAuthenticated = (to: any, from: any, next: any) => {
  if (store.getters.isAuthenticated) {
    next();
    return;
  }
  next('/login');
};

const logout = async (to: any, from: any, next: any) => {
  await store.dispatch('AUTH_LOGOUT').then(() => {
    next('login');
    return;
  });
};

Vue.use(VueRouter);

const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/logout',
    name: 'logout',
    beforeEnter: logout
  },
  {
    path: '/',
    name: 'dashboard',
    component: Dashboard,
    beforeEnter: mustBeAuthenticated
  },
  {
    path: '/depot/:id',
    name: 'depot',
    component: Depot,
    beforeEnter: mustBeAuthenticated
  },
  {
    path: '/depots',
    name: 'depots',
    component: Depots,
    beforeEnter: mustBeAuthenticated
  },
  {
    path: '/settings',
    name: 'settings',
    component: Settings,
    beforeEnter: mustBeAuthenticated
  },
];

const router = new VueRouter({
  mode: 'history',
  routes
});

export default router;
